module.exports = __webpack_public_path__ + "static/media/img14.522eb9a1.JPG";